import React,{useContext} from 'react'
//import { auth } from '../firebase'
import '../Styles/login.css'
import { UserContext } from '../context/UserProvider'
import {useNavigate} from 'react-router-dom';
import { useForm } from 'react-hook-form';

const Login = () => {

    const {register, handleSubmit, formState: {errors}, setError} = useForm();
    const { loginUser } = useContext(UserContext);
    const navegate = useNavigate();


    const onSubmit = async({email, password}) => {
        try{
            await loginUser(email,password);
            //console.log("Usuario ingresado");
            navegate("/");
        } catch (error) {
            //console.log(error.code);
            switch (error.code) {
                case "auth/email-already-in-use":
                    setError("email",{
                        message: "Usuario ya esta en uso."
                    })
                    break;
                case "auth/invalid-email":
                    setError("email",{
                        message: "Usuario es invalido."
                    })
                    break;
                case "auth/user-not-found":
                    setError("email",{
                        message: "Usuario no encontrado."
                    })
                    break;
                case "auth/wrong-password":
                    setError("password",{
                        message: "Contraseña incorrecta."
                    })
                    break;
                default:
                    return "Ocurrio un error en el server";
            }
        }

    };
  
    return (
        <div className="Login">
            
            <h3 className="LoginTitle">Login</h3>
            <div className="LoginContent">
                <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <label><b>Email</b></label>
                        <input
                            type="email"
                            placeholder="Ingrese Email"
                            //onChange={e => setEmail(e.target.value)}
                            //value={email}
                            {...register("email", {required:{
                                value: true
                            }
                        })}
                        />
                        <label><b>Contraseña</b></label>
                        <input
                            type="password"
                            placeholder="Ingrese Contraseña"
                            //onChange={e => setPassword(e.target.value)}
                            //value={password}
                            {...register("password")}
                        />
                        {errors.email && <span className="error_message">{errors.email.message}</span>}
                        {errors.password  && <span className="error_message">{errors.password.message}</span>}
                        <button
                            className="LoginButton"
                            type="submit"
                           
                        >
                            Ingresar
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default Login
